<template>
	<div v-if="accessoryGroupProp.length" class="accessory-picker">
		<h3 class="heading">Add your extras</h3>
		<div class="product-options product-options--accessories">
			<div class="product-options__row">
				<Accessory v-for="accessory in accessoryGroupProp" :key="accessory.id" :accessoryProp="accessory" @accessorySelected="onAccessorySlected"
				@accessoryRemoved="onAccessoryRemoved" />
			</div> <!-- product-options__row -->
		</div> <!-- product-options -->
	</div>
</template>

<script>
	import Accessory from "./Accessory.vue";

	export default {
		props: ['accessoryGroupProp'],
		data() {
			return {};
		},
		methods: {
			onAccessorySlected: function(accessory) {
				this.$emit('accessorySelected', accessory);
			},
			onAccessoryRemoved: function(accessory) {
				this.$emit('accessoryRemoved', accessory);
			}
		},
		components: {
			Accessory,
		}
	};
</script>

<style scoped>
	.accessory-picker {
		border-top: 1px solid #2b2012;
	}

	.heading {
		font-size: 16px;
		line-height: 1.2;
		margin: 10px 0;
	}
</style>